import { render, staticRenderFns } from "./CampaignCreateAccount.vue?vue&type=template&id=3a5c37a2&scoped=true"
import script from "./CampaignCreateAccount.vue?vue&type=script&lang=ts"
export * from "./CampaignCreateAccount.vue?vue&type=script&lang=ts"
import style0 from "./CampaignCreateAccount.vue?vue&type=style&index=0&id=3a5c37a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5c37a2",
  null
  
)

export default component.exports